export enum AudioInputMimeType {
    WAV = 'audio/wav',
    MPEG = 'audio/mpeg',
}
